export class I18n {
  constructor(
    locale = "fr",
    timezone = "Europe/Paris",
    currency = "€",
    tr_locale = localeTranslator[locale],
    tr_currency = currencyTranslator[currency],
  ) {
    this.#numberFormatter = new Intl.NumberFormat(tr_locale);

    this.#currencyFormatter = new Intl.NumberFormat(tr_locale, {
      style: "currency",
      currency: tr_currency,
    });

    this.#dateFormatter = new Intl.DateTimeFormat(tr_locale, {
      dateStyle: "long",
      timeZone: timezone,
    });

    this.#timeFormatter = new Intl.DateTimeFormat(tr_locale, {
      timeStyle: "short",
      timeZone: timezone,
    });
  }

  number(value) {
    return this.#numberFormatter.format(value);
  }

  currency(value) {
    return this.#currencyFormatter.format(value);
  }

  date(value) {
    return this.#dateFormatter.format(value);
  }

  time(value) {
    return this.#timeFormatter.format(value);
  }

  // private

  #numberFormatter;
  #currencyFormatter;
  #dateFormatter;
  #timeFormatter;
}
const localeTranslator = { fr: "fr-FR", en: "en-US", ch: "fr-CH" };
const currencyTranslator = { "€": "EUR", $: "USD", CHF: "CHF" };

// export const i18n = I18n();
